import { createContext, useContext, useState, ReactNode } from 'react';

type ViewMode = 'modal' | 'page';
type DesignVersion = 'standard' | 'cyberpunk';

interface ViewModeContextType {
    mode: ViewMode;
    designVersion: DesignVersion;
    toggleMode: () => void;
    toggleDesignVersion: () => void;
}

const ViewModeContext = createContext<ViewModeContextType | undefined>(undefined);

export const ViewModeProvider = ({ children }: { children: ReactNode }) => {
    const [mode, setMode] = useState<ViewMode>(() => {
        // Récupérer la préférence sauvegardée ou défaut 'modal'
        return (localStorage.getItem('dico_view_mode') as ViewMode) || 'modal';
    });

    const [designVersion, setDesignVersion] = useState<DesignVersion>(() => {
        return (localStorage.getItem('dico_design_version') as DesignVersion) || 'standard';
    });

    const toggleMode = () => {
        setMode(prev => {
            const newMode = prev === 'modal' ? 'page' : 'modal';
            localStorage.setItem('dico_view_mode', newMode);
            return newMode;
        });
    };

    const toggleDesignVersion = () => {
        setDesignVersion(prev => {
            const newVersion = prev === 'standard' ? 'cyberpunk' : 'standard';
            localStorage.setItem('dico_design_version', newVersion);
            return newVersion;
        });
    };

    return (
        <ViewModeContext.Provider value={{ mode, designVersion, toggleMode, toggleDesignVersion }}>
            {children}
        </ViewModeContext.Provider>
    );
};

export const useViewMode = () => {
    const context = useContext(ViewModeContext);
    if (context === undefined) {
        throw new Error('useViewMode must be used within a ViewModeProvider');
    }
    return context;
};
